// extracted by mini-css-extract-plugin
export default {"wrapper":"N5NbcBAmFsqNCYP9gmIa","documentsList":"hv8j_3iV2_h32ybsbSzZ","continueButton":"jvR7O7yIrJ4I845GdrcN","card":"iJTCCKw5qrumfgKcX05X"};